<template>
  <div :class="{ responsive }" class="controls">
    <div :class="{ disabled: first }" class="prev" @click="prev"/>
    <div class="current">
      <span>{{ value + 1 }}</span> / {{ total }}
    </div>
    <div :class="{ disabled: last }" class="next" @click="next"/>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },
    total: { type: Number, required: true },
    responsive: { type: Boolean, default: false },
  },
  computed: {
    first() {
      return this.value === 0;
    },
    last() {
      return this.value === this.total - 1;
    },
  },
  methods: {
    prev() {
      if (this.first) return;
      this.$emit('input', this.value - 1);
      this.$emit('prev');
    },
    next() {
      if (this.last) return;
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @include mobile {
    margin: 40px 0;
  }

  @include desktop {
    &:not(.responsive) {
      display: none;
    }
  }

  span {
    color: #83ca54;
    font-weight: 700;
    font-size: 20px;
  }

  .prev,
  .next {
    width: 8px;
    height: 12px;
    background: url('../assets/arrow.png') no-repeat center;
    cursor: pointer;
    padding: 10px;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  .next {
    transform: rotate(180deg);
  }
}
</style>